import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import Formulario from "../../../Componentes/Utils/Formulario";
import FormComp from "../../../Componentes/FormComp";
import { useModal } from "../../../contexts/ModalContext";
import { useEffect, useState } from "react";
import { formatBRLFromCents, parseCentsFromInput } from "../../../Funcoes/Money";
import styled from "styled-components";
import MultiFileUploader from "../../../Componentes/Utils/MultiFileUploader";
import { useAmbienteMedicao } from "../../../contexts/AmbienteMedicaoContext";
import useApi from "../../../hooks/useApi";

const CheckboxContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 20px 0;

    h3 {
        margin: 0;
        font-size: 16px;
        color: #555;
        text-align: center;
    }
`
const CheckboxWrapper = styled.div`
    margin: auto;
    display: flex;
    align-items: center;
    gap: 20px;
    color: #333;
    label {
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 14px;
        input {
            width: 16px;
            height: 16px;
        }
    }
`

const ModalNovoPedido = ({ onPedidoCreated }) => {

    const { ambiente } = useAmbienteMedicao();

    const { closeModal } = useModal();
    const api = useApi();

    const [saving, setSaving] = useState(false);

    const [formValues, setFormValues] = useState({
        numPedido: "",
        valorFaturamento: 0,
        valorFaturamentoDireto: 0,
        tipoContrato: "",
        nomeProjeto: "",
        pasp: "",
        descricao: "",
        contratante: "",
        observacoes: "",
        numContrato: "",
        dataContrato: "",
        art: "",
        cno: "",
        pc_pendente: false,
        proposta_pendente: false,
        contrato_pendente: false
    })

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormValues((prev) => {
            if (name === "valorFaturamento" || name === "valorFaturamentoDireto") {
                return { ...prev, [name]: parseCentsFromInput(value) }
            }
            return { ...prev, [name]: value.toUpperCase() }
        })

    }

    useEffect(() => {
        console.log(formValues)
    }, [formValues])

    const [arquivos, setArquivos] = useState([]);

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            setSaving(true);

            const formData = new FormData();
            formData.append("obra", ambiente?.id);

            //Adicionar valores dos campos do formulário ao formData
            Object.entries(formValues).forEach(([key, value]) => {
                formData.append(key, value);
            })

            arquivos.forEach((file) => {
                formData.append(`files[]`, file.file);
            })

            const { data } = await api.post("/Painel/API/ControleMedicao/SalvarPedidoCompra/", formData)
            console.log(data);

            closeModal();
            if (onPedidoCreated) {
                onPedidoCreated();
            }

        } catch (e) {

            console.error(e);

        } finally {

            setSaving(false);

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={closeModal} >
                    <Formulario onSubmit={handleSubmit} >
                        <FormComp
                            title="OBRA"
                            type="text"
                            readOnly
                            valor={ambiente?.nome || ""}
                        />
                        <FormComp
                            title="Nº PEDIDO DE COMPRA"
                            type="text"
                            valor={formValues.numPedido}
                            name="numPedido"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="VALOR FATURAMENTO"
                            type="text"
                            inputMode="numeric"
                            placeholder="R$ 0,00"
                            valor={formatBRLFromCents(formValues.valorFaturamento)}
                            name="valorFaturamento"
                            changeFunc={handleChange}
                            required
                        />
                        <FormComp
                            title="VALOR FATURAMENTO DIRETO"
                            type="text"
                            inputMode="numeric"
                            placeholder="R$ 0,00"
                            valor={formatBRLFromCents(formValues.valorFaturamentoDireto)}
                            name="valorFaturamentoDireto"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="VALOR TOTAL"
                            type="text"
                            //Somar valores de faturamento e faturamento direto e formatar para BRL
                            valor={formatBRLFromCents(formValues.valorFaturamento + formValues.valorFaturamentoDireto)}
                            readOnly
                        />
                        <FormComp
                            title="TIPO DO CONTRATO"
                            type="select"
                            options={[
                                "PRINCIPAL",
                                "SFE",
                                "FABRICAÇÃO",
                                "CLIENTE ADICIONAL"
                            ]}
                            valor={formValues.tipoContrato}
                            name="tipoContrato"
                            changeFunc={handleChange}
                            required
                        />
                        <FormComp
                            title="NOME DO PROJETO"
                            type="text"
                            valor={formValues.nomeProjeto}
                            name="nomeProjeto"
                            changeFunc={handleChange}
                            required
                        />
                        <FormComp
                            title="PASP"
                            type="text"
                            valor={formValues.pasp}
                            name="pasp"
                            changeFunc={handleChange}
                            required
                        />
                        <FormComp
                            title="DESCRIÇÃO"
                            type="text"
                            valor={formValues.descricao}
                            name="descricao"
                            changeFunc={handleChange}
                            required
                        />
                        <FormComp
                            title="CONTRATANTE"
                            type="text"
                            valor={formValues.contratante}
                            name="contratante"
                            changeFunc={handleChange}
                            required
                        />
                        <FormComp
                            title="OBSERVAÇÕES"
                            type="textarea"
                            valor={formValues.observacoes}
                            name="observacoes"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="Nº DO CONTRATO"
                            type="text"
                            valor={formValues.numContrato}
                            name="numContrato"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="DATA DO CONTRATO"
                            type="date"
                            valor={formValues.dataContrato}
                            name="dataContrato"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="ART"
                            type="text"
                            valor={formValues.art}
                            name="art"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="CNO"
                            type="text"
                            valor={formValues.cno}
                            name="cno"
                            changeFunc={handleChange}
                        />
                        <MultiFileUploader
                            files={arquivos}
                            setFiles={setArquivos}
                        />
                        <CheckboxContainer>
                            <h3>ARQUIVO PENDENTE</h3>
                            <CheckboxWrapper>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formValues.pc_pendente}
                                        onChange={(e) => setFormValues({ ...formValues, pc_pendente: e.target.checked })}
                                    />
                                    PEDIDO DE COMPRA
                                </label>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formValues.proposta_pendente}
                                        onChange={(e) => setFormValues({ ...formValues, proposta_pendente: e.target.checked })}
                                    />
                                    PROPOSTA
                                </label>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formValues.contrato_pendente}
                                        onChange={(e) => setFormValues({ ...formValues, contrato_pendente: e.target.checked })}
                                    />
                                    CONTRATO
                                </label>
                            </CheckboxWrapper>
                        </CheckboxContainer>
                        <FormComp
                            type="submit"
                            valor={saving ? "SALVANDO..." : "SALVAR"}
                            disabled={saving}
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalNovoPedido;